import React, { Component } from 'react';
import { Redirect } from 'react-router';
import { connect } from 'react-redux';
import ReactDOM from 'react-dom';
import {Link, withRouter} from 'react-router-dom';
import 'url-search-params-polyfill';
import {Helmet} from "react-helmet";

import { signIn } from '../../actions/authActions';
import { RESPONSE_STATUS } from '../../utils/constants';
import { buttonsContentManage } from '../../utils/util';
import { Loader } from 'semantic-ui-react'

import './signin.css';

class SignIn extends Component {
    //const auth = new Auth();
    //auth.login();

    constructor(props){
        super(props);

        this.state = {
            email: '',
            password: '',
            currentTarget: '',
            redirFromRecommendations: false,
            isCheckoutButton:false,
            butLoadShow:false,
            // redirFromRecommendations: this.props.lastLocation ? true : false
        };

        this.handleCancel=this.handleCancel.bind(this);
        this.handleSubmit = this.handleSubmit.bind(this);
        this.moveCaretAtEnd = this.moveCaretAtEnd.bind(this);

    }

    componentWillMount() {
        const params = new URLSearchParams(this.props.location.search);
        const activateKey = params.get('activate-key');
        if (activateKey) {
            this.activateAccount(activateKey);
        }
        if (this.props.isAuthenticated == true && localStorage.getItem("user_id")) {
            // if (!localStorage.getItem("user_has_skin_profile")) this.props.history.push('/hair/profile');
            // else this.props.history.push('/survey-result');

            let url = buttonsContentManage("login");
            this.props.history.push(url);

            // let visitedReco = localStorage.getItem('visited_recommendations');
            // if( localStorage.getItem("planTier") == '1'){
            //     this.props.history.push('/recommendations');
            // }else if(localStorage.getItem("planTier") == '2' || localStorage.getItem("planTier") == '3' ){
            //     if(visitedReco == "true"){
            //         this.props.history.push('/recommendations');
            //     }else if(visitedReco == "false"){
            //         if(localStorage.getItem("gateFeePaid") == "true"){
            //             this.props.history.push('/recommendation-landing');
            //         }else{
            //             this.props.history.push('/plan');
            //         }
            //     }
            // }else if(visitedReco == "true"){
            //     this.props.history.push('/recommendations');
            // }else if (localStorage.getItem("user_has_skin_profile")) {
            //   this.props.history.push('/survey-result');
            // }
        }
    }

    componentWillReceiveProps(nextProps) {
        if (nextProps.isAuthenticated) {
            let url = buttonsContentManage("login");
            this.props.history.push(url);

            // let visitedReco = localStorage.getItem('visited_recommendations');
            // if( localStorage.getItem("planTier") == '1'){
            //     this.props.history.push('/recommendations');
            // }else if(localStorage.getItem("planTier") == '2' || localStorage.getItem("planTier") == '3' ){
            //     if(visitedReco == "true"){
            //         this.props.history.push('/recommendations');
            //     }else if(visitedReco == "false"){
            //         if(localStorage.getItem("gateFeePaid") == "true"){
            //             this.props.history.push('/recommendation-landing');
            //         }else{
            //             this.props.history.push('/plan');
            //         }
            //     }
            // }else if(visitedReco == "true"){
            //     this.props.history.push('/recommendations');
            // }else if (localStorage.getItem("user_has_skin_profile")) {
            //   this.props.history.push('/survey-result');
            // }
        }else{
            // this.setState({isCheckoutButton:false});
        }
    }

    handleRedirectReco() {
        if (this.props.lastLocation.pathname === '/recommendations') {
            return <Redirect to='/' />
            // this.props.history.push('/');
            // this.props.history.push('/recommendations');
        }
    }

    activateAccount(key) {
        fetch('/api/activate?key=' + key, {
			method: 'GET'
		}).then(response => {
			if (response.status === RESPONSE_STATUS.OK) {
				alert("Your account is activated now!");
			} else {
                alert("There is a problem with the activation. Please try again.");
            }
		});
    }

    handleCancel(e){
        e.preventDefault();
        this.props.history.goBack();
    }

    handleSubmit(e){
        // e.preventDefault();
        const { email, password } = this.state;
        if (email && password) {
            this.setState({isCheckoutButton:true});
            this.props.dispatch(signIn(email, password)).then(resoen =>{
                this.setState({isCheckoutButton:false});
            })
        }

        // if (prevProps.lastLocation !== this.props.lastLocation) {
            // let fromReco = this.props.lastLocation || this.props.lastLocation.pathname === '/recommendations';
            // this.setState({ redirFromRecommendations: fromReco });
        // }
    }

    handleChange = (e) => {
        if(e.target.name === 'email'){
            this.setState({
                email: e.target.value,
                currentTarget:'email'
            });
        }

        if(e.target.name === 'password'){
            this.setState({
                password: e.target.value,
                currentTarget:'password'
            });

        }
    }

    componentDidMount(){
        ReactDOM.findDOMNode(this.refs.email).focus();
    }

    componentDidUpdate(prevProps, prevState){
        ReactDOM.findDOMNode(this.refs.email).value = this.state.email;
        ReactDOM.findDOMNode(this.refs.password).value = this.state.password;
        this.state.currentTarget === 'email' ? ReactDOM.findDOMNode(this.refs.email).focus() : ReactDOM.findDOMNode(this.refs.password).focus();
    }

    moveCaretAtEnd(e) {
        e.target.value = '';
        e.target.value = e.target.name === 'email' ? this.state.email : this.state.password;
    }

    renderEmailErrorMessage() {
        const hideErrorMessage = this.props.authFailed && this.props.error.statusCode === RESPONSE_STATUS.NOT_FOUND ? "" : "hide-me-transparent";
        return <div className={ "error-message " + hideErrorMessage }>{ this.props.error.message }</div>;
    }

    renderPasswordErrorMessage() {
        const hideErrorMessage = this.props.authFailed && this.props.error.statusCode === RESPONSE_STATUS.UNAUTHORIZED ? "" : "hide-me-transparent";
        return <div className={ "error-message " + hideErrorMessage }>{ this.props.error.message }</div>;
    }
    handleKeyDown(e) {
        let key = e.keyCode;
        if(key == 13){
            this.handleSubmit();
        }
    }

    render() {
        let enabled = {
            border: 0,
            background: '#ffad94',
            textDecoration:'none',
            color: '#ffffff'
        };

        return (

            <div className="signin">
                <Helmet>
                    <title>Sign In - HelloAva</title>
                    <meta name="description" content="Sign in to discover the best skin care products for your unique skin needs, powered by artificial intelligence and human expertise." />
                </Helmet>
                <div className="form">
                    <div className="title">Sign In</div>
                    <div className="form-input-row">
                        {/* onFocus={this.moveCaretAtEnd} */}
                        <input type="text"  maxlength="100" ref="email" name="email" placeholder='Email' autocomplete="off" value={this.state.email} onChange={this.handleChange} />
                    </div>
                    { this.renderEmailErrorMessage() }
                    <div className="form-input-row">
                        <input type="password" maxlength="100" ref="password" name="password" value={this.state.password} placeholder='Password' onKeyDown={this.handleKeyDown.bind(this)} onChange={this.handleChange}/>
                    </div>
                    { this.renderPasswordErrorMessage() }
                    <div className="form-action-row">
                        <button style={ this.state.email && this.state.password ? enabled : null } disabled={ !this.state.email && !this.state.password } onClick={this.handleSubmit}>
                            Sign In
                            <Loader onClick={(e)=>{ e.stopPropagation()}} active={this.state.isCheckoutButton} inverted size='huge' className={"but-load-style"}/>

                            {/* <i className="fa fa-spinner fa-pulse pay-checkout-load" style={this.state.isCheckoutButton ? {display:'block'}:{display:'none'}}></i> */}
                        </button>
                        <div className="link-wrapper">
                            <Link style={{ textDecoration:'none' }} to="/onboarding">Start the Quiz</Link><span style={{padding:'0.1em 0.5em'}}>or</span>
                            <Link style={{ textDecoration:'none' }} to="/reset-password">Forgot Password?</Link>
                        </div>
                    </div>
                </div>
            </div>
        )
    }
}

function mapStateToProps(state) {
    const {helloava} = state;
    const {isFetching, isAuthenticated, authFailed, error, userSelectPlan} = helloava.auth;
    return {isFetching, isAuthenticated, authFailed, error, userSelectPlan};
}

// function mapDispatchToProps(state) {
//     return state;
// }

export default withRouter(connect(mapStateToProps)(SignIn));



// WEBPACK FOOTER //
// ./src/views/signin/SignIn.js